module.exports = __webpack_public_path__ + "img/honda_logo.d408047b.png";